import React from 'react'
import { StyledFormElement as FormElement } from '../../../common/FormElement'
import Text from 'common/components/Text'
import { withStateHandlers } from 'recompose'

export const BlockName = ({ children, showFullName, toggleFullName }) => (
  <FormElement
    multiline={showFullName}
    onClick={toggleFullName}
    style={{ cursor: 'pointer' }}
  >
    <Text grey small bold truncate={!showFullName}>
      {children}
    </Text>
  </FormElement>
)

const BlockNameContainer = withStateHandlers(
  { showFullName: false },
  {
    toggleFullName: ({ showFullName }) => () => ({
      showFullName: !showFullName
    })
  }
)

export default BlockNameContainer(BlockName)
